'use strict';

exports.__esModule = true;
/*:: import type { entityType, branchType } from '../types/entities';*/
var ENTITIES = exports.ENTITIES = {
  ENTITIES: {
    FETCH: {
      LOADING: 'ENTITIES_FETCH',
      SUCCEEDED: 'ENTITIES_FETCH_SUCCEEDED',
      FAILED: 'ENTITIES_FETCH_FAILED'
    },
    EDIT: {
      LOADING: 'ENTITIES_EDIT',
      SUCCEEDED: 'ENTITIES_EDIT_SUCCEEDED',
      FAILED: 'ENTITIES_EDIT_FAILED'
    }
  },
  BRANCHES: {
    FETCH: {
      LOADING: 'ENTITIES_BRANCHES_FETCH',
      SUCCEEDED: 'ENTITIES_BRANCHES_FETCH_SUCCEEDED',
      FAILED: 'ENTITIES_BRANCHES_FETCH_FAILED'
    },
    EDIT: {
      LOADING: 'ENTITIES_BRANCHES_EDIT',
      SUCCEEDED: 'ENTITIES_BRANCHES_EDIT__SUCCEEDED',
      FAILED: 'ENTITIES_BRANCHES_EDIT_FAILED'
    },
    FETCH_BRANCH_INSURANCES: {
      LOAD: 'INSURANCE_BRANCH_FETCH_LOAD',
      SUCCESS: 'INSURANCE_BRANCH_FETCH_SUCCESS',
      FAIL: 'INSURANCE_BRANCH_FETCH_FAIL',
      RESET: 'INSURANCE_BRANCH_FETCH_RESET',
      RESET_DONE: 'INSURANCE_BRANCH_FETCH_RESET_DONE'
    },
    SET_BRANCH_INSURANCES: {
      LOAD: 'INSURANCE_BRANCH_SET_LOAD',
      SUCCESS: 'INSURANCE_BRANCH_SET_SUCCESS',
      FAIL: 'INSURANCE_BRANCH_SET_FAIL'
    }
  },
  MODAL: {
    EDIT_ENTITY_TOGGLE: 'ENTITIES_MODAL_EDIT_ENTITY_TOGGLE',
    SET_ENTITY_KEY: 'ENTITIES_MODAL_EDIT_SET_KEY',
    EDIT_BRANCH_TOGGLE: 'ENTITIES_MODAL_EDIT_BRANCH_TOGGLE',
    SET_BRANCH_KEY: 'BRANCHES_MODAL_EDIT_SET_KEY',
    USER_INFO_TOGGLE: 'ENTITIES_MODAL_USER_INFO_TOGGLE',
    SET_USER_KEY: 'USER_MODAL_EDIT_SET_KEY',
    BRANCH_INSURANCES_TOGGLE: 'INSURANCES_MODAL_BRANCH_INSURANCES_TOGGLE',
    HOME_VISITS_DR_STATS_TOGGLE: 'HOME_VISITS_DR_STATS_TOGGLE',
    SET_HOME_VISITS_DR_STATS_DETAILS: 'SET_HOME_VISITS_DR_STATS_DETAILS'
  },
  USERS: {
    ADD: {
      LOADING: 'ENTITIES_USERS_ADD',
      SUCCEEDED: 'ENTITIES_USERS_ADD_SUCCEEDED',
      FAILED: 'ENTITIES_USERS_ADD_FAILED'
    },
    FETCH: {
      LOADING: 'ENTITIES_USERS_FETCH',
      SUCCEEDED: 'ENTITIES_USERS_FETCH_SUCCEEDED',
      FAILED: 'ENTITIES_USERS_FETCH_FAILED'
    },
    FETCH_BRANCHES: {
      LOADING: 'ENTITIES_USERS_BRANCHES_FETCH',
      SUCCEEDED: 'ENTITIES_USERS_BRANCHES_FETCH_SUCCEEDED',
      FAILED: 'ENTITIES_USERS_BRANCHES_FETCH_FAILED'
    }
  },
  HIDE_SNACK_BAR: 'ENTITY_HIDE_SNACK_BAR',
  HOME_VISITS_DR_STATS: {
    LOADING: 'HOME_VISITS_DR_STATS_FETCH',
    SUCCEEDED: 'HOME_VISITS_DR_STATS_SUCCEEDED',
    FAILED: 'HOME_VISITS_DR_STATS_FAILED'
  },
  HOME_VISITS_DR_LIVE_STATUS: {
    LOADING: 'HOME_VISITS_DR_LIVE_STATUS_FETCH',
    SUCCEEDED: 'HOME_VISITS_DR_LIVE_STATUS_SUCCEEDED',
    FAILED: 'HOME_VISITS_DR_LIVE_STATUS_FAILED'
  }
};

var getEntities = exports.getEntities = function getEntities(entityKeys /*: Array<string>*/) /*: Object*/ {
  return {
    type: ENTITIES.ENTITIES.FETCH.LOADING,
    entityKeys: entityKeys
  };
};

var getBranches = exports.getBranches = function getBranches(branchKeys /*: Array<string>*/) {
  var statusIdOnly /*: boolean*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: ENTITIES.BRANCHES.FETCH.LOADING,
    branchKeys: branchKeys,
    statusIdOnly: statusIdOnly
  };
};

var getUsers = exports.getUsers = function getUsers(users /*: Map<string, Array<string>>*/, branchKey /*: string*/) {
  return {
    type: ENTITIES.USERS.FETCH.LOADING,
    users: users,
    branchKey: branchKey
  };
};

var getUsersBranches = exports.getUsersBranches = function getUsersBranches(users /*: Map<string, Array<string>>*/) {
  return {
    type: ENTITIES.USERS.FETCH_BRANCHES.LOADING,
    users: users
  };
};

var addUser = exports.addUser = function addUser(userDetails /*: Object*/, entitiesKeys /*: Array<string>*/) {
  return {
    type: ENTITIES.USERS.ADD.LOADING,
    userDetails: userDetails,
    entitiesKeys: entitiesKeys
  };
};

var setCurrentEntityKey = exports.setCurrentEntityKey = function setCurrentEntityKey(entityKey /*: string*/) {
  return {
    type: ENTITIES.MODAL.SET_ENTITY_KEY,
    entityKey: entityKey
  };
};

var editEntity = exports.editEntity = function editEntity(entity /*: entityType*/) {
  return {
    type: ENTITIES.ENTITIES.EDIT.LOADING,
    entity: entity
  };
};

var toggleEditEntityModal = exports.toggleEditEntityModal = function toggleEditEntityModal(show /*: Boolean*/) {
  return {
    type: ENTITIES.MODAL.EDIT_ENTITY_TOGGLE,
    show: show
  };
};

var setCurrentBranchKey = exports.setCurrentBranchKey = function setCurrentBranchKey(branchKey /*: string*/) {
  return {
    type: ENTITIES.MODAL.SET_BRANCH_KEY,
    branchKey: branchKey
  };
};

var editBranch = exports.editBranch = function editBranch(branch /*: branchType*/) {
  return {
    type: ENTITIES.BRANCHES.EDIT.LOADING,
    branch: branch
  };
};

var toggleEditBranchModal = exports.toggleEditBranchModal = function toggleEditBranchModal(show /*: Boolean*/) {
  return {
    type: ENTITIES.MODAL.EDIT_BRANCH_TOGGLE,
    show: show
  };
};

// get default insurance companies assigned on a branch
var loadBranchInsurances = exports.loadBranchInsurances = function loadBranchInsurances(branchKey /*: string*/) {
  return {
    type: ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.LOAD,
    branchKey: branchKey
  };
};
// set updates and changes on insurance companies assigned on a branch
var updateBranchInsurances = exports.updateBranchInsurances = function updateBranchInsurances(branchKey /*: string*/, insurances /*: Array<string>*/) {
  return {
    type: ENTITIES.BRANCHES.SET_BRANCH_INSURANCES.LOAD,
    branchKey: branchKey,
    insurances: insurances
  };
};

var resetBranchInsurances = exports.resetBranchInsurances = function resetBranchInsurances() {
  return {
    type: ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.RESET
  };
};

var toggleBranchInsurancesModal = exports.toggleBranchInsurancesModal = function toggleBranchInsurancesModal(show /*: Boolean*/) {
  return {
    type: ENTITIES.MODAL.BRANCH_INSURANCES_TOGGLE,
    show: show
  };
};

var setCurrentUserKey = exports.setCurrentUserKey = function setCurrentUserKey(userKey /*: string*/, branchKey /*: string*/) {
  return {
    type: ENTITIES.MODAL.SET_USER_KEY,
    userKey: userKey,
    branchKey: branchKey
  };
};

var toggleUserInfoModalModal = exports.toggleUserInfoModalModal = function toggleUserInfoModalModal(show /*: Boolean*/) {
  return {
    type: ENTITIES.MODAL.USER_INFO_TOGGLE,
    show: show
  };
};

var hideSnackBar = exports.hideSnackBar = function hideSnackBar() {
  return {
    type: ENTITIES.HIDE_SNACK_BAR
  };
};

var toggleHomeVisitsDrStatsModal = exports.toggleHomeVisitsDrStatsModal = function toggleHomeVisitsDrStatsModal(isOpen /*: Boolean*/) {
  return {
    type: ENTITIES.MODAL.HOME_VISITS_DR_STATS_TOGGLE,
    isOpen: isOpen
  };
};

var setHomeVisitsDrStatsQueryData = exports.setHomeVisitsDrStatsQueryData = function setHomeVisitsDrStatsQueryData(doctorDetails /*: Object*/) {
  return {
    type: ENTITIES.MODAL.SET_HOME_VISITS_DR_STATS_DETAILS,
    doctorDetails: doctorDetails
  };
};

var homeVisitsDrStatsLoad = exports.homeVisitsDrStatsLoad = function homeVisitsDrStatsLoad(SupplierKey /*: String*/, CountryId /*: Number*/, FilterStatsByDate /*: String*/, BranchKey /*: String*/) {
  return {
    type: ENTITIES.HOME_VISITS_DR_STATS.LOADING,
    SupplierKey: SupplierKey,
    CountryId: CountryId,
    FilterStatsByDate: FilterStatsByDate,
    BranchKey: BranchKey
  };
};

var homeVisitsDrStatsSuccess = exports.homeVisitsDrStatsSuccess = function homeVisitsDrStatsSuccess(data /*: Object*/) {
  return {
    type: ENTITIES.HOME_VISITS_DR_STATS.SUCCEEDED,
    data: data
  };
};

var homeVisitsDrStatsFail = exports.homeVisitsDrStatsFail = function homeVisitsDrStatsFail(errorMessage /*: string*/) {
  return {
    type: ENTITIES.HOME_VISITS_DR_STATS.FAILED,
    errorMessage: errorMessage
  };
};

var loadHomeVisitsDrLiveStatus = exports.loadHomeVisitsDrLiveStatus = function loadHomeVisitsDrLiveStatus(accKeys /*: Array<string>*/) {
  return {
    type: ENTITIES.HOME_VISITS_DR_LIVE_STATUS.LOADING,
    accKeys: accKeys
  };
};

var loadHomeVisitsDrLiveStatusSuccess = exports.loadHomeVisitsDrLiveStatusSuccess = function loadHomeVisitsDrLiveStatusSuccess(data /*: Object*/) {
  return {
    type: ENTITIES.HOME_VISITS_DR_LIVE_STATUS.SUCCEEDED,
    data: data
  };
};

var loadHomeVisitsDrLiveStatusFail = exports.loadHomeVisitsDrLiveStatusFail = function loadHomeVisitsDrLiveStatusFail() {
  return {
    type: ENTITIES.HOME_VISITS_DR_LIVE_STATUS.FAILED
  };
};